import { IconButton, Tooltip } from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import type { MouseEvent } from "react";
import type { AutoTransactionRuleDto, TransactionId } from "../api/types";

interface AutoTransactionSuggestionButtonProps {
  transactionId: TransactionId;
  rules: AutoTransactionRuleDto[] | undefined;
  onOpenSuggestions: (
    event: MouseEvent<HTMLElement>,
    txId: TransactionId,
  ) => void;
  size?: "small" | "medium" | "large";
}

export const AutoTransactionSuggestionButton = ({
  transactionId,
  rules,
  onOpenSuggestions,
  size = "small",
}: AutoTransactionSuggestionButtonProps) => {
  if (!rules || rules.length === 0) {
    return null;
  }

  return (
    <Tooltip title="View suggestions">
      <IconButton
        size={size}
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          onOpenSuggestions(e, transactionId);
        }}
      >
        <LightbulbIcon fontSize={size === "small" ? "small" : "medium"} />
      </IconButton>
    </Tooltip>
  );
};
